function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
const styles = {
  root: process.env.NODE_ENV === "production" ? {
    name: "103ly3d",
    styles: "display:flex;justify-content:space-between;width:100%;margin-top:1.25rem;margin-bottom:1.25rem"
  } : {
    name: "1q7r0rc-root",
    styles: "display:flex;justify-content:space-between;width:100%;margin-top:1.25rem;margin-bottom:1.25rem;label:root;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  side: process.env.NODE_ENV === "production" ? {
    name: "1u9rdyl",
    styles: "display:flex;align-items:flex-end;& > * + *{margin-left:1.25rem;}"
  } : {
    name: "1qcirmw-side",
    styles: "display:flex;align-items:flex-end;& > * + *{margin-left:1.25rem;};label:side;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
/**
 * A container to layout buttons in a split row on the bottom of a form.
 */
export function ButtonRow(props) {
  return <div data-testid="button-row" css={[styles.root, props.outerStyle, process.env.NODE_ENV === "production" ? "" : ";label:ButtonRow;"]}>
			<div css={[styles.side, props.leftStyle, process.env.NODE_ENV === "production" ? "" : ";label:ButtonRow;"]}>{props.left}</div>

			<div css={[styles.side, props.rightStyle, process.env.NODE_ENV === "production" ? "" : ";label:ButtonRow;"]}>{props.right}</div>
		</div>;
}